import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Restore animation position if it was saved
    const savedPosition = sessionStorage.getItem('marqueePosition')
    const savedTime = sessionStorage.getItem('marqueeTime')
    
    if (savedPosition && savedTime) {
      const elapsed = Date.now() - parseInt(savedTime)
      const animationDuration = 21600 // 21.6s in ms
      const currentPosition = (parseFloat(savedPosition) + (elapsed / animationDuration) * 100) % 100
      
      this.element.style.animationDelay = `-${(currentPosition / 100) * animationDuration}ms`
    }
    
    // Save position before navigation
    document.addEventListener('turbo:before-visit', this.savePosition.bind(this))
  }
  
  savePosition() {
    const style = window.getComputedStyle(this.element)
    const transform = style.transform
    
    // Calculate rough position percentage
    if (transform !== 'none') {
      const matrix = transform.match(/matrix\((.+)\)/)
      if (matrix) {
        const values = matrix[1].split(', ')
        const translateX = parseFloat(values[4])
        const width = this.element.scrollWidth / 2
        const position = ((translateX / width) * 100) % 100
        
        sessionStorage.setItem('marqueePosition', Math.abs(position))
        sessionStorage.setItem('marqueeTime', Date.now())
      }
    }
  }
  
  disconnect() {
    document.removeEventListener('turbo:before-visit', this.savePosition.bind(this))
  }
}

